import { Link } from "react-router-dom";

const STEPS = [
  {
    href: "/settings/account",
    title: "Complete your profile",
    description: "Name, title, and assistant preferences.",
  },
  {
    href: "/settings/workspace-overview",
    title: "Set up your workspace",
    description: "Create an org and invite teammates.",
  },
  {
    href: "/settings/companies",
    title: "Provision portfolio companies",
    description:
      "Add the companies you run. Bind Apollo/CSV aliases so feeds map correctly.",
  },
  {
    href: "/settings/connections",
    title: "Connect your sources",
    description:
      "Connect Apollo, Slack, External DynamoDB, or email/CSV push so Today has real signals.",
  },
  {
    href: "/settings/ai",
    title: "Configure AI providers",
    description: "Connect models and set defaults for the assistant.",
  },
  {
    href: "/docs",
    title: "Read the docs",
    description:
      "How Today works, how feeds sync, Observability downloads, and the ops playbook.",
  },
] as const;

export function SettingsGettingStartedPage() {
  return (
    <>
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-foreground">Get started</h1>
        <p className="text-muted-foreground">
          Finish these steps to get the most from your command centre.
        </p>
      </header>

      <ol className="flex flex-col gap-3">
        {STEPS.map((step, i) => (
          <li key={step.href}>
            <Link
              to={step.href}
              className="flex items-start gap-4 rounded-lg border border-border bg-card p-4 transition hover:bg-muted/10"
            >
              <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-brand-soft text-sm font-semibold text-brand">
                {i + 1}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground">{step.title}</p>
                <p className="text-xs text-muted-foreground">{step.description}</p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </>
  );
}
